module.exports = {"title":"Contacts | BBQ Agency","layout":"Contacts","path":"/contacts/","body":""}


//////////////////
// WEBPACK FOOTER
// ./pages/contacts.md
// module id = 455
// module chunks = 0